import { helper } from "@ember/component/helper"
import { devLessonEditorSwitch } from "../lib/dev-lesson-editor-switch"

export function devLessonForcedLegacyHelperFn(args: [string, string]) {
  const [courseId, dateString] = args
  return devLessonEditorSwitch.isForcedLegacy(courseId, dateString)
}

const devLessonForcedLegacyHelper = helper(devLessonForcedLegacyHelperFn)
export default devLessonForcedLegacyHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "dev-lesson-forced-legacy": typeof devLessonForcedLegacyHelper
  }
}
